module.exports = __webpack_public_path__ + "static/media/cs.e2c37204.png";